import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPopover from '../ui/InfoPopover';
import type { ContentMasterEmptyFieldPolicy } from '../../store/slices/contentMasterSlice';

const POLICY_OPTIONS: Array<{
  value: ContentMasterEmptyFieldPolicy;
  labelKey: string;
  hintKey: string;
}> = [
  {
    value: 'keepOriginal',
    labelKey: 'content_master_bulk_empty_policy_keep',
    hintKey: 'content_master_bulk_empty_policy_keep_hint',
  },
  {
    value: 'overwriteEmpty',
    labelKey: 'content_master_bulk_empty_policy_overwrite',
    hintKey: 'content_master_bulk_empty_policy_overwrite_hint',
  },
  {
    value: 'reject',
    labelKey: 'content_master_bulk_empty_policy_reject',
    hintKey: 'content_master_bulk_empty_policy_reject_hint',
  },
];

export interface EmptyFieldPolicyControlProps {
  /** Unique radio-group name per modal instance. */
  name: string;
  value: ContentMasterEmptyFieldPolicy;
  disabled: boolean;
  onChange: (next: ContentMasterEmptyFieldPolicy) => void;
}

/**
 * "What to do with empty fields?" radio group of the classic Content Master
 * bulk-generate forms (`emptyFieldPolicy` of POST /bulk/generate and
 * POST /bulk/generate-by-filters). Not rendered for the marketplace/SCX
 * listing flow - the parameter does not apply there.
 */
const EmptyFieldPolicyControl: React.FC<EmptyFieldPolicyControlProps> = ({
  name,
  value,
  disabled,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <fieldset className="content-master-bulk-modal__groups">
      <legend className="content-master-bulk-modal__field-label">
        {t('content_master_bulk_empty_policy_label')}
      </legend>
      {POLICY_OPTIONS.map((option) => (
        <label key={option.value} className="content-master-bulk-modal__checkbox">
          <input
            type="radio"
            name={name}
            className="content-master-checkbox"
            value={option.value}
            checked={value === option.value}
            disabled={disabled}
            onChange={() => onChange(option.value)}
          />
          <span>{t(option.labelKey)}</span>
          <InfoPopover text={t(option.hintKey)} ariaLabel={t(option.labelKey)} />
        </label>
      ))}
    </fieldset>
  );
};

export default EmptyFieldPolicyControl;
